/* BRWN CLUB — shared overlay scroll lock */
(function () {
  'use strict';

  var LOCK_REASONS = [
    'brwnlux-drawer-open',
    'bc-cart-open',
    'bc-size-guide-open',
    'bc-lightbox-open',
    'bc-nav-open'
  ];

  function body() { return document.body; }

  function hasActiveLock() {
    var b = body();
    if (!b) return false;
    return LOCK_REASONS.some(function (reason) { return b.classList.contains(reason); });
  }

  function sync() {
    var b = body();
    var html = document.documentElement;
    if (!b || !html) return;

    if (hasActiveLock()) {
      b.classList.add('brwn-scroll-locked');
      html.classList.add('brwn-scroll-locked');
      b.style.overflow = 'hidden';
    } else {
      b.classList.remove('brwn-scroll-locked');
      html.classList.remove('brwn-scroll-locked');
      b.style.overflow = '';
      html.style.overflow = '';
    }
  }

  window.BRWNScroll = {
    lock: function (reason) {
      var b = body();
      if (!b || !reason) return;
      b.classList.add(reason);
      sync();
    },
    unlock: function (reason) {
      var b = body();
      if (!b || !reason) return;
      b.classList.remove(reason);
      sync();
    },
    sync: sync,
    hasActiveLock: hasActiveLock
  };

  window.addEventListener('pageshow', sync);
  document.addEventListener('visibilitychange', sync);
})();
